import { classNames } from '@/lib/utils';
import type { ModoAlicante } from '@/lib/types';
import InfoTooltip from '@/components/ui/InfoTooltip';

const OPCIONES: { valor: ModoAlicante; label: string }[] = [
  { valor: 'todas', label: 'Todas' },
  { valor: 'sin', label: 'Sin Alicante' },
  { valor: 'solo', label: 'Solo Alicante' },
];

/**
 * Separa Alicante del resto de zonas en Finance y en Reservas. Son operativas
 * distintas —otro equipo, otros propietarios— y mezclarlas distorsiona
 * cualquier media, así que el filtro permite mirar el negocio sin ellas o solo
 * ellas, no únicamente esconderlas.
 *
 * Quién es de Alicante lo dice el prefijo del nickname del listing (`AL|`), la
 * misma convención que usan gastos y reviews: el campo `zone` del CRM no está
 * relleno en todas las propiedades y dejaría fuera a las que le faltan.
 */
export default function FiltroAlicante({
  valor,
  onChange,
}: {
  valor: ModoAlicante;
  onChange: (valor: ModoAlicante) => void;
}) {
  return (
    <div className="min-h-11 flex items-center gap-2">
      <span className="text-sm text-sereno-dark/60">Alicante:</span>
      <div className="inline-flex rounded-lg border border-sereno-dark/15 overflow-hidden">
        {OPCIONES.map((o) => (
          <button
            key={o.valor}
            onClick={() => onChange(o.valor)}
            className={classNames(
              'min-h-11 px-3 text-xs font-medium transition-colors',
              valor === o.valor ? 'bg-sereno-dark text-white an-active' : 'bg-white text-sereno-dark/60 hover:bg-sereno-blue/20'
            )}
          >
            {o.label}
          </button>
        ))}
      </div>
      <InfoTooltip text="Los pisos de Alicante son los que llevan el prefijo «AL|» en Hostify. «Sin Alicante» los deja fuera de todos los cálculos —KPIs, gráficas, ocupación y tablas—; «Solo Alicante» mira únicamente esos." />
    </div>
  );
}
